import type { IdentifierKind } from '../types/domain.types';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PHONE_DIGITS = 10;

export const PHONE_DIGITS = 10;
const COUNTRY_CODE = '91';
const TRUNK_PREFIX = '0';

export type IdentifierProblem = 'EMPTY' | 'INVALID';

export const identifierKind = (value: string): IdentifierKind | null => {
  const trimmed = value.trim();
  if (trimmed === '') return null;
  if (trimmed.includes('@')) return EMAIL.test(trimmed) ? 'EMAIL' : null;
  const digits = trimmed.replace(/\D/g, '');
  return digits.length >= MIN_PHONE_DIGITS ? 'PHONE' : null;
};

export const looksSubmittable = (value: string): boolean => identifierKind(value) !== null;

export const normalisePhoneInput = (raw: string): string => {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === PHONE_DIGITS + COUNTRY_CODE.length && digits.startsWith(COUNTRY_CODE)) {
    return digits.slice(COUNTRY_CODE.length);
  }
  if (digits.length === PHONE_DIGITS + TRUNK_PREFIX.length && digits.startsWith(TRUNK_PREFIX)) {
    return digits.slice(TRUNK_PREFIX.length);
  }
  return digits;
};

export const submittableIdentifier = (mode: IdentifierKind, value: string): string =>
  mode === 'PHONE' ? normalisePhoneInput(value) : value.trim();

export const identifierProblem = (mode: IdentifierKind, value: string): IdentifierProblem | null => {
  const submitted = submittableIdentifier(mode, value);
  if (submitted === '') return 'EMPTY';
  if (mode === 'PHONE') return submitted.length === PHONE_DIGITS ? null : 'INVALID';
  return EMAIL.test(submitted) ? null : 'INVALID';
};
